import { SET_CREATIVE_BEING_EDITED } from './actionTypes';

const setCreativeBeingEdited = creative => ({
    type: SET_CREATIVE_BEING_EDITED,
    payload: creative,
});

export default setCreativeBeingEdited;
